import React, {Component} from 'react'
import PropTypes from 'prop-types'


class ItemMainDetails extends Component {
    render() {
        const {item} = this.props
        const {name, address1, address2, city, state, country, postalCode, phone, qship} = item

        return (
            <div className="ItemMainDetails">
                <div className="Address">
                    <h3>Shipping address</h3>
                    <div className="Details">
                        <div className="font-weight-bold mb-2">{name}</div>
                        <div className="mb-1">{address1} {address2}</div>
                        <div className="mb-1">{city} - {state} - {postalCode}</div>
                        <div className="d-flex align-items-baseline mb-1">
                            <span>{country}</span>
                        </div>
                        {
                            !!phone &&
                            <div className="mb-2">Phone: {phone}</div>
                        }
                        {!!qship &&
                        <div className="qship">
                            <strong>qship:</strong> {qship}
                        </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

ItemMainDetails.propTypes = {
    item: PropTypes.object.isRequired,
}

export default ItemMainDetails
